import { useState, useRef, useEffect, Fragment } from "react"

// ─── PXTK Panel ──────────────────────────────────────────
const PXTK_DATA = [
  { id:"TK.CL.BLN", name:"Boongke liệu ngầm", type:"Boongke/Silo", qty:2, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.CLR", name:"Máy cấp liệu ngầm", type:"Máy", qty:2, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.P2LN", name:"Palang điện 2 tấn liệu ngầm", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT01", name:"Băng tải số 1 (Băng tải cấp liệu ngầm)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.B3A", name:"Boongke than 3A", type:"Boongke/Silo", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT02", name:"Băng tải số 2 (Dưới silo than)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.N4T", name:"Máy nghiền 4 trục", type:"Máy", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.P5MN", name:"Palang điện 5 tấn máy nghiền 4 trục", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT03", name:"Băng tải số 3 (Dưới máy nghiền 4 trục)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT04", name:"Băng tải số 4 (Trạm trung chuyển)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.P2TC", name:"Palang điện 2 tấn trạm trung chuyển", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT05", name:"Băng tải số 5 (Băng tải 2 chiều)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.P2HC", name:"Palang điện 2 tấn BT 2 chiều", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT06", name:"Băng tải số 6 (Băng tải lên liệu 2 Silo than)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BPL", name:"Boongke chứa liệu phối", type:"Boongke/Silo", qty:9, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.CLMT", name:"Máy cấp liệu mâm tròn", type:"Máy", qty:4, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.CBDL", name:"Cân băng tải định lượng", type:"Băng tải", qty:9, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BVN", name:"Boongke vôi nung", type:"Boongke/Silo", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.CVN", name:"Cân vít xoắn vôi nung", type:"Khác", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.VVN", name:"Vít xoắn cấp vôi nung", type:"Khác", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT07", name:"Băng tải số 7 (Băng tải phối liệu chính)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.LBPL", name:"Hệ thống lọc bụi phối liệu", type:"Lọc bụi", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.MT01", name:"Máy trộn số 1 (Ø2500x8000mm)", type:"Máy", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT08", name:"Băng tải số 8 (Từ máy trộn số 1 đến máy trộn số 2)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.MT02", name:"Máy trộn số 2 (Ø2500x8000mm)", type:"Máy", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BT09", name:"Băng tải số 9 (Từ máy trộn số 2 đến đỉnh silo thiêu kết)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.BLR", name:"Boongke chứa liệu rải thiêu kết", type:"Boongke/Silo", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.CL.04KV", name:"Hệ thống điện 0,4kV cấp liệu thiêu kết", type:"Điện", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.BT10", name:"Băng tải số 10 (Băng tải bố liệu thiêu kết)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.MTK", name:"Máy thiêu kết 36m2", type:"Máy", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.QGC", name:"Quạt hút gió chính thiêu kết SJ4000-1.033/0.875", type:"Quạt", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.P10GC", name:"Palang điện 10 tấn nhà quạt hút gió chính", type:"Quạt", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.OKG", name:"Ống khói gạch", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.LDN", name:"Lò dự nhiệt thiêu kết", type:"Lò", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.P10TK", name:"Palang điện 10 tấn xe thiêu kết", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.XTP", name:"Xích cào thủy phong", type:"Khác", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.NMT", name:"Cụm nghiền 1 trục Ø1100x1860", type:"Khác", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.SCN", name:"Sàng rung chịu nhiệt SZR1545", type:"Sàng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.MLM", name:"Máy làm mát", type:"Máy", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.P5DM", name:"Palăng điện 5 tấn đuôi máy làm mát", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.BT11", name:"Băng tải số 11 (Băng tải thành phẩm)", type:"Băng tải", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.BT12", name:"Băng tải số 12 (BT quặng thành phẩm ra ngoài)", type:"Băng tải", qty:1, since:"10/2019", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.STP", name:"Sàng rung quặng thiêu kết thành phẩm", type:"Sàng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.LBTD", name:"Lọc bụi tĩnh điện", type:"Lọc bụi", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.LBDM", name:"Lọc bụi đuôi máy", type:"Lọc bụi", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.BTHS", name:"Bơm nước tuần hoàn sạch thiêu kết", type:"Bơm", qty:2, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.BTLM", name:"Bơm nước nóng lên tháp làm mát", type:"Bơm", qty:2, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.TLM", name:"Tháp làm mát", type:"Tháp", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.OKT", name:"Hệ thống đường ống cung cấp khí than cho phân xưởng thiêu kết", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.DOK", name:"Hệ thống đường ống khí Oxy, khí Ni-tơ, khí nén", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.DON", name:"Hệ thống đường ống cung cấp nước cho phân xưởng thiêu kết", type:"Đường ống", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.DKGS", name:"Hệ thống điều khiển giám sát phòng trung tâm", type:"Điều khiển", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.P2SC", name:"Palang điện 2 tấn sửa chữa cơ điện", type:"Thiết bị nâng", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"TK.TK.04KV", name:"Hệ thống điện 0,4kV thiêu kết", type:"Điện", qty:1, since:"10/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"DH.KLH.TK", name:"Hệ thống điều hòa phân xưởng Thiêu kết", type:"Khác", qty:1, since:"09/2015", status:"ok", alarm:false, lastSeen:"12/03/2026 08:00" },
]

const STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng" },
  open:    { bg:"#dbeafe", color:"#2563eb", label:"Mở" },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK" },
}

// ─── Silo Balance ─────────────────────────────────────────

import { SiloGauge, SiloDetailPanel, SiloBalanceView, ZoneGauge, SinterBelt, SinteringLineView } from './SharedComponents'

// ─── Tiến Trình Thiêu Kết ─────────────────────────────────

const ORE_BINS = [
  { id:"B1", label:"Ore bin 1",       fill:72, color:"#64748b", active:true  },
  { id:"B2", label:"Ore bin 2",       fill:58, color:"#64748b", active:true  },
  { id:"B3", label:"Ore bin 3",       fill:81, color:"#64748b", active:true  },
  { id:"B4", label:"Flux bin 1",      fill:44, color:"#2563eb", active:true  },
  { id:"B5", label:"Flux bin 2",      fill:37, color:"#2563eb", active:false },
  { id:"B6", label:"Ore bin quick",   fill:65, color:"#64748b", active:true  },
  { id:"B7", label:"Lime bin",        fill:29, color:"#f59e0b", active:true  },
  { id:"B8", label:"Fuel bin 1",      fill:53, color:"#ef4444", active:true  },
  { id:"B9", label:"Fuel bin 2",      fill:41, color:"#ef4444", active:false },
]

const CONVEYORS = [
  { id:"CV-01", label:"Mix-1 Expansion", speed:1.2,  unit:"m/s", running:true,  alarm:false },
  { id:"CV-02", label:"Mix-2 Expansion", speed:1.05, unit:"m/s", running:true,  alarm:false },
  { id:"CV-03", label:"Máy rải liệu",    speed:8.6,  unit:"m/min",running:true, alarm:false },
  { id:"CV-04", label:"Belt sinter",     speed:61.1, unit:"m/min",running:true, alarm:false },
  { id:"CV-05", label:"Băng tải nóng",   speed:0.8,  unit:"m/s", running:true,  alarm:true  },
  { id:"CV-06", label:"Băng tải nguội",  speed:0.6,  unit:"m/s", running:false, alarm:false },
  { id:"CV-07", label:"Thành phẩm",      speed:1.1,  unit:"m/s", running:true,  alarm:false },
]

const PROCESS_STEPS = [
  {
    id:"PS-01", label:"Tiếp nhận & Nghiền",
    icon:"🪨", color:"#64748b",
    status:"running", value:null,
    subs:["Ore bin ×3","Flux bin ×2","Fuel bin ×2"],
  },
  {
    id:"PS-02", label:"Phối liệu",
    icon:"⚖", color:"#2563eb",
    status:"running", value:"8.6 t/h",
    subs:["Rải liệu 8.6 m/min","Mix-1 Cylinder","Mix-2 Cylinder"],
  },
  {
    id:"PS-03", label:"Thiêu kết",
    icon:"🔥", color:"#ef4444",
    status:"running", value:"1040 °C", alarm:true,
    subs:["TE1206: 1040°C","Tốc độ: 61.1 m/min","8 zones dépression"],
  },
  {
    id:"PS-04", label:"Làm nguội",
    icon:"❄", color:"#0ea5e9",
    status:"running", value:"320 °C",
    subs:["Băng tải nóng","Băng tải nguội","Quạt làm nguội"],
  },
  {
    id:"PS-05", label:"Thành phẩm",
    icon:"✅", color:"#22c55e",
    status:"running", value:"42 t/h",
    subs:["Sàng phân loại","Thành phẩm belt","Xuất kho"],
  },
]

const CTRL_PANELS = [
  { id:"CP-01", label:"CRT Thủ công",  active:false, color:"#64748b" },
  { id:"CP-02", label:"CRT Tự động",   active:true,  color:"#22c55e" },
  { id:"CP-03", label:"Tập trung vận", active:true,  color:"#22c55e" },
  { id:"CP-04", label:"Tản mạn trạng", active:false, color:"#64748b" },
  { id:"CP-05", label:"Tuần tự khởi",  active:true,  color:"#2563eb" },
  { id:"CP-06", label:"Dừng khẩn cấp", active:false, color:"#ef4444" },
  { id:"CP-07", label:"Hệ thống dừng", active:false, color:"#ef4444" },
]

// Hopper/bin SVG (triangular bin shape)
function BinShape({ fill=50, color="#64748b", alarm=false, active=true, width=44, height=60 }) {
  const fillH = Math.min(fill/100, 1) * (height - 18)
  const fc    = active ? color : "#e2e8f0"
  return (
    <svg viewBox={`0 0 ${width} ${height+8}`} style={{width, height:height+8, display:"block", flexShrink:0}}>
      {/* Bin body: trapezoid */}
      <polygon
        points={`4,2 ${width-4},2 ${width-10},${height-8} ${10},${height-8}`}
        fill="white" stroke={alarm?"#fca5a5":"#e2e8f0"} strokeWidth={1.5}/>
      {/* Fill */}
      <polygon
        points={`5,2 ${width-5},2 ${width-10},${height-8} ${10},${height-8}`}
        fill={alarm?"#fef2f2":"#f8fafc"} stroke="none"/>
      <clipPath id={`clip-${width}-${height}-${fill}`}>
        <polygon points={`5,2 ${width-5},2 ${width-10},${height-8} ${10},${height-8}`}/>
      </clipPath>
      <rect
        x={5} y={2+(height-10-fillH)} width={width-10} height={fillH}
        fill={alarm?"#fca5a5":fc} opacity={active?0.7:0.3}
        clipPath={`url(#clip-${width}-${height}-${fill})`}/>
      {/* Outlet triangle */}
      <polygon
        points={`${10},${height-8} ${width-10},${height-8} ${width/2},${height}`}
        fill={fc} opacity={active?0.8:0.3}/>
      {/* Level % */}
      <text x={width/2} y={height-18} textAnchor="middle"
        fontSize={9} fontWeight="700" fill={alarm?"#ef4444":"#374151"}>{fill}%</text>
      {/* Alarm dot */}
      {alarm && <circle cx={width-5} cy={5} r={4} fill="#ef4444"/>}
    </svg>
  )
}

// Conveyor belt mini SVG
function BeltMini({ running=true, color="#22c55e", w=80, h=14 }) {
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w, height:h, display:"block"}}>
      <rect x={0} y={2} width={w} height={h-4} rx={3}
        fill={running?"#f1f5f9":"#f8fafc"} stroke={running?color:"#e2e8f0"} strokeWidth={1}/>
      {Array.from({length:10},(_,i)=>(
        <rect key={i} x={i*(w/10)+1} y={3} width={w/10-2} height={h-6} rx={1}
          fill={running?color+"33":"#e2e8f0"} opacity={0.6}/>
      ))}
      {running && <polygon points={`${w-10},${h/2-3} ${w-4},${h/2} ${w-10},${h/2+3}`} fill={color}/>}
    </svg>
  )
}

function TienTrinhView() {
  const [selectedConv,    setSelectedConv]    = useState(null)
  const [selectedStep,    setSelectedStep]    = useState(null)
  const [selectedBin,     setSelectedBin]     = useState(null)
  const [hoveredId,       setHoveredId]       = useState(null)
  const [systemRunning,   setSystemRunning]   = useState(true)
  const [activeBottomTab, setActiveBottomTab] = useState("Tiến Trình Thiêu Kết")

  const alarmsN   = CONVEYORS.filter(c=>c.alarm).length
  const stoppedN  = CONVEYORS.filter(c=>!c.running).length
  const totalFlow = 42

  // ── same HPipe/Arrow as SiloBalanceView ──
  const HPipe = ({color="#22c55e", active=true, width=28, flow=null, unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width, height:3,
        background:active?color:"#e2e8f0",
        borderRadius:2, opacity:active?1:0.4,
        boxShadow:active?`0 0 4px ${color}66`:"none"
      }}/>
      {flow!=null && <span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600}}>{flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{
      fontSize:10, color:active?color:"#e2e8f0",
      flexShrink:0, lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"
    }}>{dir==="right"?"▶":"◀"}</span>
  )
  const ColHeader = ({title,count,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      {extra||<button style={{
        width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
        cursor:"pointer",fontSize:14,color:"white",
        display:"flex",alignItems:"center",justifyContent:"center",
        boxShadow:"0 1px 4px rgba(34,197,94,.4)"
      }}>+</button>}
    </div>
  )

  // Right detail panel
  const DetailPanel = () => {
    const item = selectedConv || selectedStep || selectedBin
    if (!item) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>🏭</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn một phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào thiết bị, băng tải hoặc bước quy trình để xem thông tin
        </span>
      </div>
    )
    const isBin   = item.fill != null
    const isStep  = item.subs != null
    const isConv  = item.speed != null
    const alarm   = item.alarm || (!item.active && isBin) || (!item.running && isConv)
    const trend   = Array.from({length:18},(_,i)=>
      25+Math.abs(Math.sin(i/2.5))*55+(Math.random()-.5)*10
    )
    const fields  = isBin ? [
      ["Remplissage", `${item.fill}%`],
      ["Statut",      item.active?"Đang chạy":"Dừng"],
      ["Type",        item.label],
    ] : isStep ? [
      ["Étape",       item.label],
      ["Valeur",      item.value||"—"],
      ["Statut",      item.status==="running"?"Đang chạy":"Dừng"],
    ] : [
      ["Tốc độ",      `${item.speed} ${item.unit}`],
      ["Trạng thái",  item.running?"Đang chạy":"Dừng"],
      ["Cảnh báo",    item.alarm?"Có":"Không"],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",
          borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label}</span>
          </div>
          {alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
            display:"inline-flex",alignItems:"center",justifyContent:"center",
            fontSize:9,color:"white",fontWeight:900}}>!</span>}
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
          ))}
        </div>
        {isStep&&item.subs&&(
          <div style={{padding:"8px 14px",background:"#eff6ff",borderBottom:"1px solid #dbeafe"}}>
            {item.subs.map(s=>(
              <div key={s} style={{fontSize:10,color:"#1d4ed8",padding:"2px 0"}}>· {s}</div>
            ))}
          </div>
        )}
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Trạng thái"?alarm?"#dc2626":"#16a34a":"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,
                background:(item.color||"#22c55e"),
                borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>

      {/* ── Main content ── */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>
        <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

          {/* KPI strip */}
          <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
            {[
              {label:"Thành phẩm",       value:`${totalFlow} t/h`,    icon:"✅", color:"#22c55e"},
              {label:"Băng tải hoạt động", value:`${CONVEYORS.filter(c=>c.running).length}/${CONVEYORS.length}`, icon:"⚙", color:"#2563eb"},
              {label:"Silô hoạt động",   value:`${ORE_BINS.filter(b=>b.active).length}/${ORE_BINS.length}`,     icon:"🗄", color:"#64748b"},
              {label:"Cảnh báo",         value:`${alarmsN}`,          icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
            ].map(k=>(
              <div key={k.label} style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
                flex:1,minWidth:110,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
              }}>
                <span style={{fontSize:18}}>{k.icon}</span>
                <div>
                  <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                  <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Bin row ── */}
          <div style={{
            background:"white",border:"1px solid #e2e8f0",borderRadius:8,
            padding:"12px 14px",marginBottom:14,
            boxShadow:"0 1px 4px rgba(0,0,0,0.05)"
          }}>
            <div style={{fontSize:11,fontWeight:700,color:"#64748b",
              letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>
              Silô nguyên liệu
            </div>
            <div style={{display:"flex",alignItems:"flex-end",gap:6,overflowX:"auto",paddingBottom:4}}>
              {ORE_BINS.map((b,idx)=>{
                const isSel = selectedBin?.id===b.id
                return (
                  <div key={b.id}
                    onClick={()=>{setSelectedBin(prev=>prev?.id===b.id?null:b); setSelectedConv(null); setSelectedStep(null)}}
                    onMouseEnter={()=>setHoveredId(b.id)}
                    onMouseLeave={()=>setHoveredId(null)}
                    style={{
                      display:"flex",flexDirection:"column",alignItems:"center",gap:3,
                      cursor:"pointer",flex:1,minWidth:44,
                      background:isSel?"#eff6ff":"transparent",
                      borderRadius:6,padding:"4px 2px",
                      border:`1px solid ${isSel?"#2563eb":"transparent"}`,
                      transition:"all .15s"
                    }}>
                    <BinShape fill={b.fill} color={b.color} active={b.active} width={44} height={52}/>
                    <span style={{fontSize:8,color:isSel?"#2563eb":"#374151",
                      fontWeight:600,textAlign:"center",lineHeight:1.2,width:44}}>
                      {b.label}
                    </span>
                    {!b.active&&<span style={{fontSize:7,background:"#fee2e2",color:"#dc2626",
                      padding:"1px 4px",borderRadius:4,fontWeight:600}}>Dừng</span>}
                  </div>
                )
              })}
            </div>
            {/* Conveyor line below bins */}
            <div style={{marginTop:10,display:"flex",alignItems:"center",gap:3}}>
              <HPipe color="#2563eb" active={true} width={20}/>
              <Arrow color="#2563eb" active={true} dir="right"/>
              <div style={{flex:1}}>
                <BeltMini running={true} color="#2563eb" w="100%" h={14}/>
              </div>
              <Arrow color="#2563eb" active={true} dir="right"/>
              <span style={{fontSize:9,fontWeight:600,color:"#2563eb",whiteSpace:"nowrap"}}>Phối liệu</span>
            </div>
          </div>

          {/* ── Process flow ── */}
          <div style={{
            background:"white",border:"1px solid #e2e8f0",borderRadius:8,
            padding:"12px 14px",marginBottom:14,
            boxShadow:"0 1px 4px rgba(0,0,0,0.05)"
          }}>
            <div style={{fontSize:11,fontWeight:700,color:"#64748b",
              letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>
              Quy trình sản xuất
            </div>
            <div style={{display:"flex",alignItems:"center",gap:0,overflowX:"auto"}}>
              {PROCESS_STEPS.map((step,idx)=>{
                const isSel = selectedStep?.id===step.id
                const isHov = hoveredId===step.id
                return (
                  <Fragment key={step.id}>
                    <div
                      onClick={()=>{setSelectedStep(prev=>prev?.id===step.id?null:step); setSelectedConv(null); setSelectedBin(null)}}
                      onMouseEnter={()=>setHoveredId(step.id)}
                      onMouseLeave={()=>setHoveredId(null)}
                      style={{
                        display:"flex",flexDirection:"column",alignItems:"center",gap:6,
                        background:isSel?"#eff6ff":isHov?"#f8fafc":"white",
                        border:`2px solid ${isSel?"#2563eb":step.alarm?"#fca5a5":"#e2e8f0"}`,
                        borderRadius:8,padding:"10px 10px",cursor:"pointer",
                        boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.12)":isHov?"0 2px 8px rgba(0,0,0,0.07)":"none",
                        transition:"all .15s",flex:1,minWidth:100,textAlign:"center"
                      }}>
                      {step.alarm&&<div style={{
                        position:"absolute",marginTop:-8,marginLeft:60,
                        width:14,height:14,borderRadius:"50%",background:"#ef4444",
                        display:"inline-flex",alignItems:"center",justifyContent:"center",
                        fontSize:7,color:"white",fontWeight:900}}>!</div>}
                      <span style={{fontSize:22}}>{step.icon}</span>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:isSel?"#2563eb":"#374151",
                          lineHeight:1.2}}>{step.label}</div>
                        {step.value&&<div style={{fontSize:11,fontWeight:800,
                          color:step.alarm?"#ef4444":step.color,marginTop:3,fontFamily:"monospace"}}>
                          {step.value}
                        </div>}
                      </div>
                      <div style={{
                        width:8,height:8,borderRadius:"50%",
                        background:step.status==="running"?step.color:"#e2e8f0",
                        boxShadow:step.status==="running"?`0 0 5px ${step.color}`:"none"
                      }}/>
                    </div>
                    {idx<PROCESS_STEPS.length-1&&(
                      <div style={{display:"flex",flexDirection:"column",alignItems:"center",
                        gap:2,flexShrink:0,padding:"0 4px"}}>
                        <HPipe color={step.color} active={step.status==="running"} width={24}/>
                        <Arrow color={step.color} active={step.status==="running"} dir="right"/>
                      </div>
                    )}
                  </Fragment>
                )
              })}
            </div>
          </div>

          {/* ── Conveyor & control panels (2 cols) ── */}
          <div style={{display:"flex",gap:12}}>

            {/* Conveyors */}
            <div style={{flex:2}}>
              <ColHeader title="Băng tải & Thiết bị" count={CONVEYORS.length}/>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {CONVEYORS.map(cv=>{
                  const isSel = selectedConv?.id===cv.id
                  const isHov = hoveredId===cv.id
                  return (
                    <div key={cv.id}
                      onClick={()=>{setSelectedConv(prev=>prev?.id===cv.id?null:cv); setSelectedStep(null); setSelectedBin(null)}}
                      onMouseEnter={()=>setHoveredId(cv.id)}
                      onMouseLeave={()=>setHoveredId(null)}
                      style={{
                        background:"white",
                        border:`2px solid ${isSel?"#2563eb":cv.alarm?"#fca5a5":cv.running?"#e2e8f0":"#f1f5f9"}`,
                        borderRadius:8,padding:"10px 12px",cursor:"pointer",
                        boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.12)":isHov?"0 2px 8px rgba(0,0,0,0.07)":"none",
                        transition:"all .15s",opacity:cv.running?1:0.65
                      }}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                        <div style={{flex:1}}>
                          <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{cv.label}</div>
                          <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{cv.id}</div>
                        </div>
                        {cv.alarm&&<span style={{
                          width:16,height:16,borderRadius:"50%",background:"#ef4444",
                          display:"inline-flex",alignItems:"center",justifyContent:"center",
                          fontSize:8,color:"white",fontWeight:900,flexShrink:0}}>!</span>}
                        <span style={{
                          fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
                          background:cv.running?"#dcfce7":"#fee2e2",
                          color:cv.running?"#16a34a":"#dc2626"
                        }}>{cv.running?"Chạy":"Dừng"}</span>
                      </div>
                      <BeltMini running={cv.running}
                        color={cv.alarm?"#ef4444":cv.running?"#22c55e":"#e2e8f0"}
                        w={120} h={14}/>
                      <div style={{marginTop:5,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{fontSize:9,color:"#94a3b8"}}>Tốc độ</span>
                        <span style={{fontSize:12,fontWeight:800,fontFamily:"monospace",
                          color:cv.running?"#0f172a":"#94a3b8"}}>
                          {cv.speed} <span style={{fontSize:8,fontWeight:400,color:"#94a3b8"}}>{cv.unit}</span>
                        </span>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Control panel (湿料运输系统连锁 equivalent) */}
            <div style={{flex:1,minWidth:170}}>
              <ColHeader
                title="Điều khiển hệ thống"
                count={CTRL_PANELS.length}
                extra={
                  <div style={{display:"flex",gap:5}}>
                    <button onClick={()=>setSystemRunning(true)} style={{
                      padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:9,
                      fontWeight:600,background:systemRunning?"#22c55e":"#f1f5f9",
                      color:systemRunning?"white":"#64748b"
                    }}>Start</button>
                    <button onClick={()=>setSystemRunning(false)} style={{
                      padding:"3px 8px",border:"none",borderRadius:5,cursor:"pointer",fontSize:9,
                      fontWeight:600,background:!systemRunning?"#ef4444":"#f1f5f9",
                      color:!systemRunning?"white":"#64748b"
                    }}>Stop</button>
                  </div>
                }
              />
              {/* Emergency stop visual — like the SCADA red block */}
              <div style={{
                background:systemRunning?"#dcfce7":"#fee2e2",
                border:`2px solid ${systemRunning?"#22c55e":"#ef4444"}`,
                borderRadius:8,padding:"8px 12px",marginBottom:10,
                textAlign:"center",
                boxShadow:systemRunning?"0 0 0 3px rgba(34,197,94,.12)":"0 0 0 3px rgba(239,68,68,.12)"
              }}>
                <div style={{fontSize:10,fontWeight:700,
                  color:systemRunning?"#16a34a":"#dc2626"}}>
                  {systemRunning?"🟢 Hệ thống hoạt động":"🔴 Hệ thống dừng"}
                </div>
              </div>
              {CTRL_PANELS.map(cp=>(
                <div key={cp.id} style={{
                  background:cp.active?"white":"#f8fafc",
                  border:`1px solid ${cp.active?cp.color+"66":"#f1f5f9"}`,
                  borderRadius:6,padding:"6px 10px",marginBottom:6,
                  display:"flex",alignItems:"center",gap:8,
                  opacity:cp.active?1:0.55
                }}>
                  <div style={{
                    width:10,height:10,borderRadius:2,flexShrink:0,
                    background:cp.active?cp.color:"#e2e8f0",
                    boxShadow:cp.active?`0 0 4px ${cp.color}`:"none"
                  }}/>
                  <span style={{fontSize:10,fontWeight:cp.active?600:400,
                    color:cp.active?"#374151":"#94a3b8",flex:1}}>{cp.label}</span>
                  <span style={{fontSize:8,fontWeight:600,
                    color:cp.active?cp.color:"#94a3b8"}}>
                    {cp.active?"ON":"OFF"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Right detail panel ── */}
        <div style={{
          width:268,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          <DetailPanel/>
        </div>
      </div>

      {/* ── Bottom tab bar (identical to SCADA image) ── */}
      <div style={{
        background:"white",borderTop:"2px solid #e2e8f0",
        display:"flex",alignItems:"stretch",flexShrink:0,overflowX:"auto"
      }}>
        {[
          {label:"RECEIVED & CRUSHED", color:"#22c55e"},
          {label:"Công nghệ Thiêu Kết",color:"#2563eb"},
          {label:"Tiến Trình Thiêu Kết",color:"#f59e0b"},
          {label:"Phối Liệu",           color:"#64748b"},
          {label:"Lịch Sử",             color:"#94a3b8"},
        ].map(t=>{
          const isAct = activeBottomTab===t.label
          return (
            <button key={t.label} onClick={()=>setActiveBottomTab(t.label)} style={{
              padding:"7px 16px",border:"none",cursor:"pointer",
              borderRight:"1px solid #f1f5f9",
              background:isAct?t.color+"18":"transparent",
              color:isAct?t.color:"#64748b",
              fontSize:10,fontWeight:isAct?700:500,
              borderBottom:isAct?`2px solid ${t.color}`:"2px solid transparent",
              whiteSpace:"nowrap",transition:"all .15s"
            }}>{t.label}</button>
          )
        })}
      </div>
    </div>
  )
}

function PXTKPanel() {
  const [pxtkTab,     setPxtkTab]     = useState("Tỷ Lệ Phối Liệu")
  const [selected,    setSelected]    = useState(null)
  const [filterType,  setFilterType]  = useState("Tous")
  const [search,      setSearch]      = useState("")
  const [alarmOnly,   setAlarmOnly]   = useState(false)
  const [viewMode,    setViewMode]    = useState("table") // "table" | "grid"

  const PXTK_TABS = ["Thiết bị","Tỷ Lệ Phối Liệu","Công nghệ Thiêu Kết","Tiến Trình Thiêu Kết"]

  const types = ["Tous", ...Array.from(new Set(PXTK_DATA.map(d=>d.type)))]

  const filtered = PXTK_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>

      {/* PXTK sub-tab bar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0
      }}>
        {PXTK_TABS.map(t=>(
          <button key={t} onClick={()=>setPxtkTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxtkTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxtkTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxtkTab === "Tỷ Lệ Phối Liệu" ? <SiloBalanceView/> :
       pxtkTab === "Công nghệ Thiêu Kết" ? <SinteringLineView/> :
       pxtkTab === "Tiến Trình Thiêu Kết" ? <TienTrinhView/> : (
      <>

      {/* Toolbar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"
      }}>
        {/* Search */}
        <div style={{
          display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180
        }}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}
          />
        </div>

        {/* Type filter */}
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",
              transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>

        {/* Alarm filter */}
        <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:"#374151",marginLeft:4}}>
          <button onClick={()=>setAlarmOnly(v=>!v)} style={{
            width:34,height:18,borderRadius:9,border:"none",cursor:"pointer",
            background:alarmOnly?"#ef4444":"#cbd5e1",position:"relative",transition:"background .2s",flexShrink:0
          }}>
            <div style={{
              width:12,height:12,borderRadius:"50%",background:"white",
              position:"absolute",top:3,left:alarmOnly?19:3,transition:"left .2s"
            }}/>
          </button>
          Alarmes seulement
        </label>

        <div style={{flex:1}}/>

        {/* View toggle */}
        <div style={{display:"flex",gap:2,border:"1px solid #e2e8f0",borderRadius:6,overflow:"hidden"}}>
          {[["table","≡"],["grid","⊞"]].map(([mode,icon])=>(
            <button key={mode} onClick={()=>setViewMode(mode)} style={{
              padding:"4px 10px",border:"none",cursor:"pointer",fontSize:14,
              background:viewMode===mode?"#2563eb":"white",
              color:viewMode===mode?"white":"#94a3b8",
              transition:"all .15s"
            }}>{icon}</button>
          ))}
        </div>

        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} équipements</span>
      </div>

      {/* Main area */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        {/* Table / Grid */}
        <div style={{flex:1,overflow:"auto",padding:"12px 16px"}}>
          {viewMode === "table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"white",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"9px 12px",textAlign:"left",color:"#64748b",fontWeight:600,whiteSpace:"nowrap"}}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(d=>{
                  const isSel = selected?.id===d.id
                  const ss = STATUS_STYLES[d.status] || STATUS_STYLES.ok
                  return (
                    <tr key={d.id}
                      onClick={()=>setSelected(isSel?null:d)}
                      style={{
                        background:isSel?"#eff6ff":"white",
                        borderBottom:"1px solid #f1f5f9",cursor:"pointer",
                        transition:"background .1s"
                      }}
                      onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background="#f8fafc"}}
                      onMouseLeave={e=>{if(!isSel)e.currentTarget.style.background="white"}}
                    >
                      <td style={{padding:"9px 12px",fontFamily:"monospace",color:"#94a3b8",fontSize:10}}>{d.id}</td>
                      <td style={{padding:"9px 12px",fontWeight:600,color:"#0f172a"}}>{d.name}</td>
                      <td style={{padding:"9px 12px",color:"#64748b"}}>{d.type}</td>
                      <td style={{padding:"9px 12px"}}>
                        <span style={{
                          background:ss.bg,color:ss.color,
                          padding:"2px 8px",borderRadius:10,fontWeight:600,fontSize:10,whiteSpace:"nowrap"
                        }}>{ss.label}</span>
                      </td>
                      <td style={{padding:"9px 12px",fontWeight:700,color:d.alarm?"#ef4444":"#0f172a"}}>
                        {d.value} <span style={{fontWeight:400,color:"#94a3b8",fontSize:10}}>{d.unit}</span>
                      </td>
                      <td style={{padding:"9px 12px",textAlign:"center"}}>
                        {d.alarm && <span style={{
                          display:"inline-flex",alignItems:"center",justifyContent:"center",
                          width:20,height:20,borderRadius:"50%",background:"#ef4444",
                          color:"white",fontSize:9,fontWeight:900
                        }}>!</span>}
                      </td>
                      <td style={{padding:"9px 12px",color:"#94a3b8",fontSize:10,whiteSpace:"nowrap"}}>{d.lastSeen}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
              {filtered.map(d=>{
                const isSel = selected?.id===d.id
                const ss = STATUS_STYLES[d.status]||STATUS_STYLES.ok
                return (
                  <div key={d.id} onClick={()=>setSelected(isSel?null:d)} style={{
                    background:"white",borderRadius:8,padding:"14px",
                    border:`2px solid ${isSel?"#2563eb":d.alarm?"#fca5a5":"#e2e8f0"}`,
                    cursor:"pointer",transition:"all .15s",
                    boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":"0 1px 3px rgba(0,0,0,0.05)"
                  }}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                      <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{d.id}</span>
                      {d.alarm && <div style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",display:"flex",alignItems:"center",justifyContent:"center"}}>
                        <span style={{fontSize:8,color:"white",fontWeight:900}}>!</span>
                      </div>}
                    </div>
                    <div style={{fontSize:12,fontWeight:700,color:"#0f172a",marginBottom:4,lineHeight:1.3}}>{d.name}</div>
                    <div style={{fontSize:10,color:"#64748b",marginBottom:10}}>{d.type}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{fontSize:18,fontWeight:800,color:d.alarm?"#ef4444":"#0f172a"}}>
                        {d.value}<span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{d.unit}</span>
                      </span>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",borderRadius:10,fontSize:9,fontWeight:600}}>
                        {ss.label}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {/* Right detail panel */}
        <div style={{
          width:260,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          {!selected ? (
            <div style={{
              height:"100%",display:"flex",flexDirection:"column",
              alignItems:"center",justifyContent:"center",
              color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8
            }}>
              <span style={{fontSize:28}}>🔧</span>
              <span style={{fontWeight:500}}>Chưa chọn đối tượng</span>
              <span style={{fontSize:11,color:"#cbd5e1"}}>Nhấp vào thiết bị để xem thông tin</span>
            </div>
          ) : (
            <div>
              {/* Header */}
              <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #f1f5f9",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <span style={{fontSize:10,color:"#94a3b8",fontFamily:"monospace"}}>{selected.id} · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{selected.name}</span>
                </div>
                <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
              </div>

              {/* Tabs */}
              <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                  <button key={t} style={{
                    padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,fontWeight:i===0?700:400,
                    color:i===0?"#2563eb":"#94a3b8",
                    borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"
                  }}>{t}</button>
                ))}
              </div>

              {/* Fields */}
              {[
                ["Tên",         selected.name],
                ["ID",          selected.id],
                ["Type",        selected.type],
                ["Trạng thái",      STATUS_STYLES[selected.status]?.label||"—"],
                ["Giá trị hiện tại", `${selected.value} ${selected.unit}`],
                ["Cảnh báo",      selected.alarm?"⚠ Active":"Không có"],
                ["Lần đọc cuối", selected.lastSeen],
              ].map(([k,v])=>(
                <div key={k} style={{
                  display:"flex",justifyContent:"space-between",alignItems:"flex-start",
                  padding:"6px 14px",borderBottom:"1px solid #f8fafc",gap:8
                }}>
                  <span style={{fontSize:11,color:"#94a3b8",flexShrink:0}}>{k}</span>
                  <span style={{
                    fontSize:11,fontWeight:600,textAlign:"right",wordBreak:"break-all",
                    color:k==="Cảnh báo"&&selected.alarm?"#ef4444":"#0f172a"
                  }}>{v}</span>
                </div>
              ))}

              {/* Mini chart */}
              <div style={{padding:"8px 14px 0",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:6}}>
                DERNIÈRE HEURE
              </div>
              <div style={{padding:"8px 14px 14px",background:"#f8fafc"}}>
                <MiniBarChart color={selected.alarm?"#ef4444":"#22c55e"} count={20}/>
              </div>
            </div>
          )}
        </div>
      </div>
      </>
    )}
    </div>
  )
}

export default PXTKPanel
